module.exports = __webpack_public_path__ + "img/Dantam Hair 02.6ad2fb27.jpg";